import { IRequestParams } from '@portals/fetch-api';
import { instructionArticleUrl } from '@/api/endpoints/article-one';
import { DEFAULT_API_CACHE_PARAMS } from '@/_constants/cache-params';
import { ERevalidatePeriods } from '@/api/constants';

export type TGetArticlesParams = {
  articleId: string;
  endpoint: string;
  language?: string;
  country?: string;
};

export const makeRequestConfig = (
  params: TGetArticlesParams,
): IRequestParams => ({
  endpoint: params.endpoint,
  body: {
    params: {
      id: params.articleId,
      language: params.language,
    },
  },
  browserCacheParams: {
    ...DEFAULT_API_CACHE_PARAMS,
    strategy: 'CacheFirst',
    requestCacheKey: `${instructionArticleUrl}:${params.articleId}:${params.language}`,
    expires: ERevalidatePeriods.TEN_MINUTES,
  },
});
